import * as React from 'react';
import Modal from '@mui/material/Modal';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useState } from 'react';
import { useCookies } from 'react-cookie';
import GatewayAdminDelete from "./GatewayAdminModalDelete"
import baseUrlApi from '../../../lib/baseUrlApi';
import {ApiRequest} from "../../../Consts/ApiRequest";
import {modalProps} from "../../../Consts/constants";
import {useNavigate} from "react-router-dom";

type GatewayAdminInputs = {
  gatewayID: string;
  controlID: string;
};
interface ActionProps {
  // gatewayID: string,
  controlID: string,
  prcKind: number,
  gatewayRecno: number,
  setState: Function
  getGatewaySensor: Function
}

const GatewayAdminModalEdit = (props: ActionProps) => {
  // const [gatewayID, setGatewayID] = useState<string>(props.gatewayID);
  const [controlID, setControlID] = useState<string>(props.controlID);
  const [gatewayRecno, setGatewayRecno] = useState<number>(props.gatewayRecno);
  const prcKind = props.prcKind;
  const navigate = useNavigate();

  const [open, setOpen] = React.useState(false);
  const [error, setError] = useState<string[]>([]);

  const [gatewayAdminData1, setGatewayAdminData] = useState<GatewayAdminInputs[]>([]);
  const getGatewaySensor = props.getGatewaySensor;
  const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);

  const { register: register, handleSubmit: handleSubmit, formState: { errors: errors } } = useForm<GatewayAdminInputs>();
  const authority = cookies.authority;
  // console.log(authority);

  const resetData = async() => {
    console.log(".........");
    console.log(props.controlID);
    setControlID(props.controlID);
    setGatewayRecno(props.gatewayRecno);
    setGatewayAdminData([]);
    setError([]);
  };

  const handleOpen = async() => {
    resetData();
    setOpen(true);
  }
  const handleClose = async() => {
    resetData();
    setOpen(false);
  }

  const rules = {
    required: '',
    maxLength: {
      value: 100,
      message: ""
    },
    pattern: {
      value: /^[a-zA-Z0-9\-]+$/,
      message: ""
    }
  }
  function errorCallback(error:any){
    if (error.response && error.response.status === 401) {
      console.error("Error token error:", error);
      removeCookie('access_token', {path: '/'});
      removeCookie('authority', {path: '/'});
      removeCookie('siteId', {path: '/'});
      removeCookie('siteRecno', {path: '/'});
      navigate("logout");
    }
    console.error("Error fetching dataSite:", error);
  }

  const onSubmit: SubmitHandler<GatewayAdminInputs> = async (data) => {
    try {
      let params = {
        "prcKind": prcKind,
        "deviceInfo": {
          "gatewayRecno": gatewayRecno,
          "gatewayID": controlID,
          "controlID": controlID,
        }
      };
      const token = cookies.access_token || "";

      ApiRequest.registGateway(params, token, (response:any) => {
        setError(response.data.messsages);
        if (response.data.result == 0) {
          handleClose();
          getGatewaySensor();
          setGatewayAdminData(response.data);
        }
      }, (error:any) => {
        errorCallback(error);
      });
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("エラーが発生しました");
    }
  };

  return (
    <div>
      {!(authority === 3 || authority === 4) && (
        <button onClick={handleOpen} className={`btn ${prcKind === 1 ? 'btn-blue-line' : 'btn-blue'}`}>
          <i className={prcKind === 1 ? 'icon-edit-b' : 'icon-add-w'}></i>
          {prcKind === 1 ? '編集' : 'Gateway追加'}
        </button>
      )}

      <Modal {...modalProps} open={open}>
        <div className="modal-wrapper" style={{ display: "flex" }} id="modal-message">
          <div className="modal">
            <div className="modal-header">
              <div className="modal-title">
                {prcKind === 1 ? 'Gateway編集' : 'Gateway新規追加'}
              </div>
              <a onClick={handleClose} className="modal-close"></a>
            </div>
            <div className="modal-body">
              <div className="edit-box">
                <div className="edit-box-elm">
                  {
                    (error && error.length > 0) ?
                      <ul className="error-box">
                        {error.map((err, index) => <li key={index}>{err}</li>)}
                      </ul>
                      : null
                  }
                  <div className="edit-box-elm-name">
                    Gateway管理番号
                    <span className="required">
                    </span></div>
                  <div className="edit-box-elm-input">
                    <input
                      type="text"
                      value={controlID}
                      placeholder="Gateway管理番号"
                      onChange={(e) => setControlID(e.target.value)}
                      className={"col-320 " + (errors.controlID ? "error-disp" : "")}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="model-action-sub">
                {prcKind === 1 ? (
                  <GatewayAdminDelete controlID={controlID}
                    //  controlID={controlID}
                    gatewayRecno={gatewayRecno} closeModal={handleClose}
                    getGatewaySensor={getGatewaySensor} />
                ) : null}
              </div>
              <div className="model-action-main">
                <button className="btn btn-blue-line">
                  <a onClick={handleClose} className="">
                    キャンセル
                  </a>
                </button>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <button className="btn btn-blue col-160">
                    <i className="icon-check-w"></i>確定
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default GatewayAdminModalEdit;
